//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.fragment

import blazern.lexisoup.graphql.model.type.TranslationsSet
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public data class TranslationsSetFields(
  public val original: Original,
  public val translations: List<Translation>,
  /**
   * Possible values are 0-9
   */
  public val translationsQualities: List<Int>?,
) : TranslationsSet.Data {
  public data class Original(
    public val __typename: String,
    /**
     * Synthetic field for 'SentenceFields'
     */
    public val sentenceFields: SentenceFields,
  )

  public data class Translation(
    public val __typename: String,
    /**
     * Synthetic field for 'SentenceFields'
     */
    public val sentenceFields: SentenceFields,
  )
}
